export default "__VITE_ASSET__BrBKshKS__"